import { render, staticRenderFns } from "./browsetree.vue?vue&type=template&id=4c09d88a&scoped=true"
import script from "./browsetree.vue?vue&type=script&lang=js"
export * from "./browsetree.vue?vue&type=script&lang=js"
import style0 from "./browsetree.vue?vue&type=style&index=0&id=4c09d88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09d88a",
  null
  
)

export default component.exports